export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14863.8efe7820.jpg";